export const SAVE_ALL_VEHICLE_TYPES = 'SAVE_ALL_VEHICLE_TYPES'
export const SAVE_VEHICLE_TYPE = 'SAVE_VEHICLE_TYPE'
